module.exports = __webpack_public_path__ + "static/img/00.fe04981f.png";